// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'entity-feed.page.title': 'Timeline',
    'entity-feed.page.archive.title': 'Archived Activities',
    'entity-feed.page.search_results': 'Search Results',
    'entity-feed.page.create.title': 'Create New Activity',
    'entity-feed.page.search.title': 'Find Activities',
    'entity-feed.page.edit.title': 'Edit Activity',
    'entity-feed.page.view.title': 'View Activity',
    'entity-feed.page.all': 'All',

    'entity-feed.button.cancel': 'Cancel',
    'entity-feed.button.select': 'Select',
    'entity-feed.button.find': 'Find Activities',
    'entity-feed.button.search': 'Apply',
    'entity-feed.button.create': 'Save Activity',
    'entity-feed.button.new': 'New Activity',
    'entity-feed.button.save': 'Save Changes',
    'entity-feed.button.archive': 'Archive',
    'entity-feed.button.delete': 'Permanently Delete',
    'entity-feed.button.edit': 'Edit',
    'entity-feed.button.restore': 'Restore',
    'entity-feed.button.reset': 'Reset',

    'entity-feed.placeholder.search': 'Search activities',

    'entity-feed.link.create_first_entity_feed': 'Click here to create your first activity',
    'entity-feed.link.entity_feeds': ' Return to Timeline',
    'entity-feed.link.archive': 'Archived Activities',
    'entity-feed.link.retry': 'Click here to retry',

    'entity-feed.checkbox.all': 'Check All',
    'entity-feed.checkbox.actions_label': 'with selected',

    'entity-feed.label.from__event_date': 'From event date',
    'entity-feed.label.to__event_date': 'To event date',
    'entity-feed.label.event_date': 'Event Date',

    'entity-feed.label.entity_name': 'Entity',
    'entity-feed.label.created_by': 'Created By',

    'entity-feed.label.reference': 'Reference',

    'entity-feed.label.from__follow_up_on': 'From follow up on',
    'entity-feed.label.to__follow_up_on': 'To follow up on',
    'entity-feed.label.follow_up_on': 'Follow Up On',

    'entity-feed.label.message': 'Message',

    'entity-feed.label.from__created_at': 'From created at',
    'entity-feed.label.to__created_at': 'To created at',
    'entity-feed.label.created_at': 'Created At',

    'entity-feed.label.from__updated_at': 'From updated at',
    'entity-feed.label.to__updated_at': 'To updated at',
    'entity-feed.label.updated_at': 'Updated At',

    'entity-feed.label.from__deleted_at': 'From deleted at',
    'entity-feed.label.to__deleted_at': 'To deleted at',
    'entity-feed.label.deleted_at': 'Deleted At',

    'entity-feed.label.status': 'Status',

    'entity-feed.sort.field_label': 'Field',
    'entity-feed.sort.direction_label': 'Direction',
    'entity-feed.sort.direction_ascending': 'Ascending',
    'entity-feed.sort.direction_descending': 'Descending',

    'entity-feed.modal.title.entity_feed_archive': 'Archive Activity',
    'entity-feed.modal.title.entity_feed_delete_permanently': 'Delete Activity',
    'entity-feed.modal.title.entity_feed_restore': 'Restore Activity',

    'entity-feed.modal.message.entity_feed_archive': 'Are you sure that you want to move this activity to the archive? | Are you sure that you want to move these activities to the archive?',
    'entity-feed.modal.message.entity_feed_delete_permanently':
        'Are you sure that you want to permanently delete this activity? This action cannot be undone. | Are you sure that you want to permanently delete these activities? This action cannot be undone.',
    'entity-feed.modal.message.entity_feed_restore': 'Are you sure that you want to restore this activity? | Are you sure that you want to restore these activities?',

    'entity-feed.success.message.entity_feed_created': 'Your activity has been created',
    'entity-feed.success.message.entity_feed_updated': 'Your activity has been updated',
    'entity-feed.success.message.entity_feed_restored': 'Your activity has been restored | All selected activities were restored',
    'entity-feed.success.message.entity_feed_deleted': 'Your activity has been permanently deleted | All selected activities were permanently deleted',
    'entity-feed.success.message.archived_entity_feeds': 'Your activity was moved to the archive | All selected activities were moved to the archive',

    'entity-feed.error.message.archived_entity_feeds': 'This activity was already moved to the archive | These activities were already moved to the archive',
    'entity-feed.error.message.entity_feed_deleted': 'This activity was already permanently deleted | These activities were already permanently deleted',
    'entity-feed.error.message.entity_feed_restored': 'This activity was already restored | These activities were already restored',
    'entity-feed.error.message.error_loading_page': 'Sorry, there was an error loading activity.| Sorry, there was an error loading activities.',

    'entity-feed.message.search.no_archived_entity_feeds': "You haven't archived any entity any feeds as yet.",
};
